export default "__VITE_ASSET__284bea9c__"